import { z } from 'zod'

export const comment = z.object({
    id: z.string(),
    content: z.string(),
    user: z.object({
        id: z.string(),
        name: z.string(),
        avatar: z.string(),
    }),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
})

export type Comment = z.infer<typeof comment>
